import React from "react";

function FacebookIcon() {
  return (
    <svg
      width='14'
      height='28'
      viewBox='0 0 14 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9.0949 28V15.2487H13.2412L13.8575 10.2561H9.0949V7.07604C9.0949 5.63537 9.48179 4.64899 11.4747 4.64899H14V0.19785C12.7713 0.0612367 11.5363 -0.00472655 10.3006 0.000263189C6.63561 0.000263189 4.11932 2.32152 4.11932 6.58285V10.2468H0V15.2393H4.12832V28H9.0949Z'
        fill='#FAF9FC'
      />
    </svg>
  );
}

export default FacebookIcon;
